import React, { Fragment, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';
import Masthead from '../components/Masthead/Masthead';
import TabControl from '../components/TabControl/TabControl';
import CategoryList from '../components/CategoryList/CategoryList';
import ContentBlock from '../components/ContentBlock/ContentBlock';
import MobileApp from '../components/MobileApp/MobileApp';
import Disclosure from '../components/Disclosure/Disclosure';
import Footer from '../components/Footer/Footer';
import * as SELECTORS from '../constants/selectors';
import useAxios from '../utils/hooks/useAxios';
import { Error, IsPending } from '../utils/SiteTools';
import { lobSourceName, defaultMetaDescription } from '../utils/LobLogicModule';

const HomePage = () => {
  const sourceName = lobSourceName;
  const { i18n } = useTranslation();
  const { data: homeContent, isPending, error } = useAxios(process.env.REACT_APP_GCDEV_API_HOME+sourceName);
  useEffect(() => {
	  i18n.changeLanguage('en');
	}, [i18n]);
  return (
    <Fragment>
      {isPending && <IsPending />}
      {(error || homeContent?.error) && <Error errorMessage={error || homeContent.error.message} /> }
      
      { (homeContent && !homeContent.error) && <main className="home-page" data-pageid="homepage">
          <Helmet>
            <html lang={i18n.language + "-US"} />
            <meta name="description" content={`${homeContent[0].metadata ? homeContent[0].metadata : defaultMetaDescription}`}/>
          </Helmet>
          <Masthead selectorKey={SELECTORS.HOME_KEY} content={homeContent[0]} />
          <TabControl selectorKey={SELECTORS.HOME_KEY} content={homeContent[0].copySubmasthead} />
          <CategoryList />
          <ContentBlock />
          <MobileApp />
          <Disclosure disclosures={homeContent[0].disclosures}  />
          <Footer footerMap={homeContent[0].mapNumber}  />
      </main> }
    </Fragment>
  )
}

export default HomePage;